import * as React from "react";
import { connect } from "react-redux";
import * as actions from "../../actions/";
import StoreStar from "../store-star";
import axios from "axios";
import CONSTS from "../../consts";
const LiquorIcon = require("!svg-react-loader?name=LiquorIcon!../../../wwwroot/img/liquor-connect-logo.svg");
export class Header extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        if (this.props.SetAuth) {
            let htmlSelector = document.querySelector("html");
            let login = Boolean(JSON.parse(htmlSelector.getAttribute("data-authenticated")));
            this.props.SetAuth(login);
            axios
                .get("/Manage/GetFavoriteStore")
                .then(response => {
                let flist = response.data.favoriteStore;
                if (this.props.GetFavorite && flist) {
                    this.props.GetFavorite(flist);
                }
            });
            this.props.SetAuth(login);
        }
    }
    render() {
        const supplier = this.props.supplier;
        const hero_image = `${CONSTS.STORAGEURL}/${CONSTS.LICENSEECONTAINER}/${supplier.Id}-Logo.jpg`;
        return (React.createElement("div", { className: "header-default" },
            React.createElement(StoreStar, { id: supplier.Id })));
    }
}
export function mapStateToProps({ shoppingList, authenticated }, OwnProps) {
    return {
        shoppingList,
        authenticated,
        supplier: OwnProps.supplier
    };
}
export function mapDispatchToProps(dispatch) {
    return {
        SetAuth: (login) => dispatch(actions.SetAuth(login)),
        GetFavorite: (flist) => dispatch(actions.GetFavorite(flist))
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Header);
//# sourceMappingURL=header-default.js.map